// 设置权限——流程
const HuaWeiRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `permission/huawei/index${i + 1}`,
  name: `permissionHuaWeiIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/huawei/index${i + 1}.vue`)
}))
const branchHuaWeiRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `permission/huawei/branch/index${i + 1}`,
  name: `permissionHuaWeiBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/huawei/branch/index${i + 1}.vue`)
}))
const MiRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `permission/mi/index${i + 1}`,
  name: `permissionMiIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/mi/index${i + 1}.vue`)
}))
const branchMiRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `permission/mi/branch/index${i + 1}`,
  name: `permissionMiBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/mi/branch/index${i + 1}.vue`)
}))
const VivoRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `permission/vivo/index${i + 1}`,
  name: `permissionVivoIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/vivo/index${i + 1}.vue`)
}))
const branchVivoRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `permission/vivo/branch/index${i + 1}`,
  name: `permissionVivoBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/permission/vivo/branch/index${i + 1}.vue`)
}))

import permissionIndex from '@/views/phoneSettings/permission/index.vue'



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'permission/index',
      name: 'permissionIndex',
      component: permissionIndex,
    },
    // 设置权限——主流程，开始
    ...HuaWeiRoutes,
    ...branchHuaWeiRoutes,

    ...MiRoutes,
    ...branchMiRoutes,

    ...VivoRoutes,
    ...branchVivoRoutes,




  ],
};
